import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { SeverityEnum } from '../enums/severity.enum';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmDialogComponent } from '../dialogs/confirm.dialog/confirm.dialog.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private apiCount = 0;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  private messageService = inject(MessageService);
  private dialogService = inject(DialogService);

  /**
   * Show toast
   *
   * @param {string} message
   * @param {string} title
   * @param {SeverityEnum} severity
   * @memberof NotificationService
   */
  showToast(message: string, title: string, severity: SeverityEnum): void {
    this.messageService.add({
      severity: severity,
      summary: title,
      detail: message,
    });
  }

  /**
   * Start / Stop loader
   *
   * @param {boolean} isActive
   * @memberof NotificationService
   */
  setLoading(isActive: boolean): void {
    if (isActive) {
      this.showLoader();
    } else {
      this.hideLoader();
    }
  }

  private showLoader() {
    if (this.apiCount === 0) {
      Promise.resolve().then(() => this.isLoadingSubject.next(true));
    }
    this.apiCount++;
  }

  private hideLoader() {
    this.apiCount--;
    if (this.apiCount === 0) {
      Promise.resolve().then(() => this.isLoadingSubject.next(false));
    }
  }

  confirm(title: string, message: string): DynamicDialogRef {
    const ref: DynamicDialogRef = this.dialogService.open(
      ConfirmDialogComponent,
      {
        header: title,
        modal: true,
        data: {
          message: message,
        },
        closable: false,
        styleClass: 'confirm-dialog',
        width: '30%',
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10000,
        maximizable: false,
      },
    );

    return ref;
  }
}
